<template>
    <zen-message-modal :isOpen="isOpen" title="Remove context?">
        Removing this context is immediate. After the context is removed, it
        will no longer adhere to the targeting rules for this segment.
        <strong>This action is irreversible.</strong>
        <template v-slot:buttons>
            <zen-button variant="primary-danger" @click="$emit('confirm')">
                Remove
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RemoveSegmentContextModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
